import UUIDBase from '../UUIDBase'
import User from '../user/User'
import Customer from './Customer'
import Pet from '../Pet'
import Item from '../inventory/Item'

export const appointmentI18nMessages = {
    en: {
        optometrist: 'Optometrist',
        customerAppointment: 'Customer Appointment',
        customer: 'Customer',
        date: 'Date',
        nextAppointment: "Next Appointment",
        appointmentDate: 'Appointment Date',
        appointment: 'Appointment',
        setBy: 'Set By',
        notes: 'Notes',
        checkinDate: 'Checkin Date & Time'
    },
    ar: {
        optometrist: 'الفاحص',
        customerAppointment: 'موعد فحص',
        customer: 'الزبون',
        date: 'التاريخ',
        nextAppointment: "الموعد القادم",
        appointmentDate: 'الموعد',
        appointment: 'موعد',
        setBy: 'تم بواسطة',
        notes: 'الملاحظات',
        checkinDate: 'وقت تسجيل الوصول'
    }
}

export interface AppointmentPaginated {
    data: Array<Appointment>,
    total: number
}

export default class Appointment extends UUIDBase {
    static from(json: Record<string, unknown> | Appointment) {
        return Object.assign(new Appointment(), json)
    }
    static ENDPOINT = '/customer/appointments'

    userID: string | undefined
    user: User | undefined

    optometristID: string | undefined
    optometrist: User | undefined

    customerID: string | undefined
    customer: Customer | undefined

    petID: string | undefined
    pet: Pet | undefined

    serviceItemID: string | undefined
    serviceItem: Item | undefined

    vetServiceID: string | undefined

    notes: string | undefined = ''
    status: string | undefined = ''

    appointmentDate: string | undefined
    requestOnlyAppointmentDate: string | undefined
    checkinDate: string | undefined
    inQueue: boolean = false;
    contacted: boolean;
}
